import ContactItem from "./ContactItem";

export {ContactGroupItem as default};

/**
* Group Item
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class ContactGroupItem extends ContactItem {
  /**
   * Contact type
   *
   * @public
   * @readonly
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  type = 'group';

  /**
   * An index of members ids
   *
   * @public
   *
   * @type {Object}
   *
   * @since 7.0.0
   */
  members = {};

  /**
   * An index of members ids
   *
   * @public
   *
   * @type {Array}
   *
   * @since 7.0.0
   */
    members_ids = [];

  /**
   * Members count
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  members_count = 0;
}